// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JWiu","toggle":"styles_toggle__U5G1I","preview":"styles_preview__2Uqxt"};